import { interviewService } from '../services/interviewService';

/**
 * Schedule interview reminders
 * This should be called by a cron job or scheduled task
 */
export async function scheduleInterviewReminders(): Promise<void> {
  try {
    // Get interviews scheduled in the next 24 hours
    const tomorrow = new Date();
    tomorrow.setHours(tomorrow.getHours() + 24);

    const upcomingInterviews = await interviewService.getInterviews({
      status: 'scheduled',
      scheduledAfter: new Date().toISOString(),
      scheduledBefore: tomorrow.toISOString()
    });

    // Send reminders for each upcoming interview
    for (const interview of upcomingInterviews) {
      const scheduledTime = new Date(interview.scheduledAt);
      const now = new Date();
      const hoursUntilInterview = (scheduledTime.getTime() - now.getTime()) / (1000 * 60 * 60);

      // Send reminder if interview is 24 hours away or 1 hour away
      if (
        (hoursUntilInterview <= 24 && hoursUntilInterview > 23) ||
        (hoursUntilInterview <= 1 && hoursUntilInterview > 0.5)
      ) {
        await interviewService.sendInterviewReminders(interview.id);
      }
    }

    console.log(`Processed ${upcomingInterviews.length} upcoming interviews for reminders`);
  } catch (error) {
    console.error('Error scheduling interview reminders:', error);
  }
}

/**
 * Initialize reminder scheduler
 * Call this function on app startup or use with a cron service
 */
export function initEmailScheduler(): void {
  // Run every hour
  setInterval(() => {
    scheduleInterviewReminders().catch(err => {
      console.error('Email scheduler error:', err);
    });
  }, 60 * 60 * 1000); // 1 hour

  // Run immediately on startup
  scheduleInterviewReminders().catch(err => {
    console.error('Initial email scheduler error:', err);
  });
}